/* eslint-disable */
import { formatDate } from 'src/helpers/date';
import POST_MEDIA_TYPES from 'src/enums/postMediaTypes';
import INTEGRATION_CHANNEL_TYPES from 'src/enums/integrationChannelTypes';

export function isVideoByExt(link) {
  const videoExts = ['.3gpp', '.3gp', '.mpeg', '.mpg', '.mov', '.flv', '.mng', '.asx', '.asf', '.wmv', '.avi', '.m4v', '.mp4'];

  return videoExts.some((element) => !!link.includes(element))
}

function prepareMediaForFacebook(post) {
  let media;
  // eslint-disable-next-line default-case
  switch (post.type) {
    case POST_MEDIA_TYPES.POST:
      // eslint-disable-next-line no-case-declarations
      const isVideo = post.media[0]?.isVideo;
      if (isVideo) {
        media = {
          type: POST_MEDIA_TYPES.POST,
          data: {
            video: post.media[0].url,
            coverImage: null,
          },
        };
      } else {
        media = {
          type: POST_MEDIA_TYPES.POST,
          data: post.media.length > 0 ? post.media.map((item) => item.url) : null,
        };
      }
      break;
    case POST_MEDIA_TYPES.FB_REELS:
      media = {
        type: POST_MEDIA_TYPES.FB_REELS,
        data: post.media[0]?.url,
      };
      break;
  }
  return media;
}
function prepareMediaCommon(post) {
  let media = null;
  if (post.media.length > 0) {
    media = post.media[0]?.isVideo ? post.media[0].url : post.media.map((item) => item.url);
  }

  return media;
}
function prepareMediaForThreads(post) {
  let media = null;
  if (post.media.length > 0) {
    media = post.media.map((item) => item.url);
  }

  return media;
}
function prepareMediaForYTShorts(post) {
  let media = null;
  if (post.media.length > 0 && post.media[0]?.isVideo) {
    media = { video: post.media[0].url, thumbnail: null };
  }

  return media;
}
function prepareMediaForTiktok(post) {
  let media = null;
  if (post.media.length > 0) {
    if (post.media[0]?.isVideo) {
      media = {
        type: 'video',
        data: post.media[0].url,
      };
    } else {
      media = {
        type: 'photos',
        data: post.media.map((item) => item.url),
      };
    }
  }

  return media;
}
function prepareMediaForPinterest(post) {
  let media = null;
  if (post.media.length > 0) {
    media = post.media[0]?.isVideo
      ? { video: post.media[0].url, coverImage: post.media[0].coverImage }
      : post.media.map((item) => item.url);
  }

  return media;
}
function prepareMediaForInstagram(post) {
  let media;
  // eslint-disable-next-line default-case
  switch (post.type) {
    case POST_MEDIA_TYPES.CAROUSEL:
      media = {
        type: POST_MEDIA_TYPES.CAROUSEL,
        images: post.media.map((item) => item.url),
      };
      break;
    case POST_MEDIA_TYPES.REELS:
      media = {
        type: POST_MEDIA_TYPES.REELS,
        video: post.media[0]?.url,
        coverImage: null,
      };
      break;
    case POST_MEDIA_TYPES.STORIES:
      media = {
        type: POST_MEDIA_TYPES.STORIES,
        item: post.media[0]?.url,
      };
      break;
  }

  return media;
}

function serializeMediaFacebook(data) {
  // eslint-disable-next-line default-case
  switch (data.media.type) {
    case POST_MEDIA_TYPES.POST:
      // eslint-disable-next-line no-case-declarations
      const isVideo = !Array.isArray(data.media.data);
      if (isVideo && data.media.data) {
        return [{
          url: data.media.data?.video ? data.media.data.video : data.media.data,
          type: 'video',
          isVideo: true,
          coverImage: undefined,
        }];
      }
      return data.media.data
        ? data.media.data.map((url) => ({
          url,
          type: 'image',
          isVideo: false,
          coverImage: undefined,
        }))
        : [];
    case POST_MEDIA_TYPES.FB_REELS:
      return data.media.data
        ? [{
          url: data.media.data,
          type: 'video',
          isVideo: true,
          coverImage: undefined,
        }]
        : [];
    default:
      if (data.media?.video) {
        return [{
          url: data.media.video,
          type: 'video',
          isVideo: true,
          coverImage: data.media.coverImage,
        }];
      }

      return data.media
        ? data.media.map((url) => ({
          url,
          type: 'image',
          isVideo: false,
          coverImage: undefined,
        }))
        : [];
  }
}

function serializeMediaCommon(data) {
  const mediaArray = Array.isArray(data.media) ? data.media : [data.media];
  return mediaArray.map((item) => {
    const isVideo = isVideoByExt(item);
    return {
      url: item,
      type: isVideo ? 'video' : 'image',
      isVideo,
      coverImage: undefined,
    };
  });
}
function serializeMediaYTShorts(data) {
  const mediaArray = Array.isArray(data.media) ? data.media : [data.media];
  return mediaArray.map((item) => {
    return {
      url: item,
      type: 'video',
      isVideo: true,
      coverImage: item.thumbnail || undefined,
    };
  });
}
function serializeMediaTiktok(data) {
  const mediaArray = Array.isArray(data.media) ? data.media : [data.media];
  if (mediaArray[0].type === 'video') {
    return [{
      url: mediaArray[0].data,
      type: 'video',
      isVideo: true,
      coverImage: undefined,
    }];
  }

  return mediaArray[0].data.map((item) => ({
    url: item,
    type: 'photos',
    isVideo: false,
    coverImage: undefined,
  }));
}
function serializeMediaPinterest(data) {
  const mediaArray = Array.isArray(data.media) ? data.media : [data.media];
  return mediaArray.map((item) => {
    const isVideo = item.video !== undefined;
    return {
      url: isVideo ? item.video : item,
      type: isVideo ? 'video' : 'image',
      isVideo,
      coverImage: isVideo ? item.coverImage : undefined,
    };
  });
}
function serializeMediaInstagram(data) {
  // eslint-disable-next-line default-case
  switch (data.media.type) {
    case POST_MEDIA_TYPES.CAROUSEL:
      return data.media.images.map((url) => ({
        url,
        type: 'image',
        isVideo: false,
        coverImage: undefined,
      }));
    case POST_MEDIA_TYPES.REELS:
      return [{
        url: data.media.video,
        type: 'video',
        isVideo: true,
        coverImage: null,
      }];
    case POST_MEDIA_TYPES.STORIES:
      // eslint-disable-next-line no-case-declarations
      const isVideo = isVideoByExt(data.media.item);
      return [{
        url: data.media.item,
        type: isVideo ? 'video' : 'image',
        isVideo,
        coverImage: undefined,
      }];
  }
}
export function generateMediaForSchema(post) {
  // eslint-disable-next-line default-case
  switch (post.templateType) {
    case INTEGRATION_CHANNEL_TYPES.FACEBOOK:
      return prepareMediaForFacebook(post);
    case INTEGRATION_CHANNEL_TYPES.PINTEREST:
      return prepareMediaForPinterest(post);
    case INTEGRATION_CHANNEL_TYPES.INSTAGRAM:
      return prepareMediaForInstagram(post);
    case INTEGRATION_CHANNEL_TYPES.TIKTOK:
      return prepareMediaForTiktok(post);
    case INTEGRATION_CHANNEL_TYPES.YT_SHORTS:
      return prepareMediaForYTShorts(post);
    case INTEGRATION_CHANNEL_TYPES.TWITTER:
    case INTEGRATION_CHANNEL_TYPES.LINKEDIN:
      return prepareMediaCommon(post);
    case INTEGRATION_CHANNEL_TYPES.THREADS:
      return prepareMediaForThreads(post);
  }
}

export function generateAdditionalData(post, channel) {
  let additionalData = null;
  if (post.templateType === INTEGRATION_CHANNEL_TYPES.PINTEREST) {
    additionalData = {
      link: post.link,
      title: post.title,
      board: channel.board
        ? {
          id: channel.board.id,
          image_cover_url: channel.board.image_cover_url,
          name: channel.board.name,
        }
        : undefined,
    };
  }

  if (post.templateType === INTEGRATION_CHANNEL_TYPES.TIKTOK) {
    const source = post.guid ? post.additionalData : post;
    additionalData = {
      privacy: source.privacy,
      disableComments: source.disableComments || false,
      disableDuet: source.disableDuet || false,
      disableStitch: source.disableStitch || false,
      isAIGC: source.isAIGC || false,
      brandContentToggle: source.brandContentToggle || false,
      brandOrganicToggle: source.brandOrganicToggle || false,
    };
  }

  if (post.templateType === INTEGRATION_CHANNEL_TYPES.YT_SHORTS) {
    const source = post.guid ? post.additionalData : post;
    additionalData = {
      title: source.title,
      categoryId: source.categoryId,
      privacyStatus: source.privacyStatus,
      license: source.license,
      notifySubscribers: source.notifySubscribers || false,
      embeddable: source.embeddable || false,
      selfDeclaredMadeForKids: source.selfDeclaredMadeForKids || false,
      tags: [],
    };
  }

  return additionalData;
}

export function serializeMediaForPost(data) {
  // eslint-disable-next-line default-case
  switch (data.socialMediaPlannerChannel.template.type) {
    case INTEGRATION_CHANNEL_TYPES.FACEBOOK:
      return serializeMediaFacebook(data);
    case INTEGRATION_CHANNEL_TYPES.PINTEREST:
      return serializeMediaPinterest(data);
    case INTEGRATION_CHANNEL_TYPES.INSTAGRAM:
      return serializeMediaInstagram(data);
    case INTEGRATION_CHANNEL_TYPES.TIKTOK:
      return serializeMediaTiktok(data);
    case INTEGRATION_CHANNEL_TYPES.YT_SHORTS:
      return serializeMediaYTShorts(data);
    case INTEGRATION_CHANNEL_TYPES.TWITTER:
    case INTEGRATION_CHANNEL_TYPES.LINKEDIN:
    case INTEGRATION_CHANNEL_TYPES.THREADS:
      return serializeMediaCommon(data);
  }
}

export function serializePostFromData(data) {
  return {
    ...data,
    media: serializeMediaForPost(data),
    publishAt: formatDate(data.publishAtUTC.timestamp * 1000, 'YYYY-MM-DDTHH:mm:ss'),
    templateType: data.socialMediaPlannerChannel.template.type,
    link: data.additionalData?.link,
    title: data.additionalData?.title,
    type: data.media?.type || POST_MEDIA_TYPES.POST,
    disableComments: data.additionalData?.disableComments || false,
    privacy: data.additionalData?.privacy,
    childPosts: data.childPosts?.map((childPost) => serializePostFromData(childPost)),
  };
}
